import { render, staticRenderFns } from "./Prototype.vue?vue&type=template&id=2982dcd4&scoped=true"
import script from "./Prototype.vue?vue&type=script&lang=js"
export * from "./Prototype.vue?vue&type=script&lang=js"
import style0 from "./Prototype.vue?vue&type=style&index=0&id=2982dcd4&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2982dcd4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/b08365e4-b55a-4269-82b4-b5e5a1490008/workspace/hsylc_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2982dcd4')) {
      api.createRecord('2982dcd4', component.options)
    } else {
      api.reload('2982dcd4', component.options)
    }
    module.hot.accept("./Prototype.vue?vue&type=template&id=2982dcd4&scoped=true", function () {
      api.rerender('2982dcd4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form/CheckboxGroup/Prototype.vue"
export default component.exports